<template>
    <nav v-if="items.length" class="seo-breadcrumbs" aria-label="Хлебные крошки">
        <ol class="seo-breadcrumbs__list">
            <li
                v-for="(item, index) in items"
                :key="`${item.name}-${index}`"
                class="seo-breadcrumbs__item"
            >
                <a
                    v-if="item.url && index < items.length - 1"
                    :href="item.url"
                    class="seo-breadcrumbs__link"
                >{{ item.name }}</a>
                <span v-else class="seo-breadcrumbs__current" aria-current="page">{{ item.name }}</span>
                <span v-if="index < items.length - 1" class="seo-breadcrumbs__sep" aria-hidden="true">/</span>
            </li>
        </ol>
    </nav>
</template>

<script setup>
import { computed } from 'vue';
import { usePage } from '@inertiajs/vue3';

const props = defineProps({
    breadcrumbs: {
        type: Array,
        default: null,
    },
    seo: {
        type: Object,
        default: null,
    },
});

const page = usePage();

const items = computed(() => {
    if (Array.isArray(props.breadcrumbs) && props.breadcrumbs.length) {
        return props.breadcrumbs;
    }

    const seo = props.seo || page.props.seo || null;
    return Array.isArray(seo?.breadcrumbs) ? seo.breadcrumbs : [];
});
</script>
